import { useState, useCallback } from 'react';
import moment from 'moment-timezone';
import { calculateDateTimeRange } from '../helpers/global';

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

const defaultDateRange = {
  startDate: moment
    .tz(tz)
    .startOf('isoWeek')
    .toDate(),
  endDate: moment
    .tz(tz)
    .endOf('isoWeek')
    .toDate(),
  key: 'selection',
  rangeType: 'This Week'
};

export const useAdvancedDateRangePicker = (initialDateRange = defaultDateRange) => {
  const [dateRange, setDateRange] = useState(initialDateRange);

  const handleNavigateDate = useCallback(
    (rangeType, direction) => {
      const { startDate, endDate } = dateRange;
      let newRangeType;

      switch (rangeType) {
        case 'Last 12 Months':
        case 'This Year':
        case 'Last Year':
          newRangeType = 'Year';
          break;
        case 'Last 3 Months':
        case 'This Quarter':
        case 'Last Quarter':
          newRangeType = 'Quarter';
          break;
        case 'This Month':
        case 'Last Month':
          newRangeType = 'Month';
          break;
        case 'This Week':
        case 'Last Week':
          newRangeType = 'Week';
          break;
        case 'Today':
          newRangeType = 'Day';
          break;
        default:
          newRangeType = 'Month';
          break;
      }

      const { startDateTime, endDateTime } = calculateDateTimeRange(startDate, endDate, newRangeType, direction);

      setDateRange({
        startDate: startDateTime,
        endDate: endDateTime,
        rangeType,
        key: 'selection'
      });
    },
    [dateRange]
  );

  const resetDateRange = useCallback(() => {
    setDateRange(defaultDateRange);
  }, []);

  const updateDateRange = useCallback(newDateRange => {
    setDateRange(newDateRange);
  }, []);

  return {
    dateRange,
    setDateRange,
    handleNavigateDate,
    resetDateRange,
    updateDateRange
  };
};
